import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

export const LIST_ELEMENTS: HTMLSerializeOptions['elements'] = {
    'unordered-list': (_, children) => `<ul>${children}</ul>`,
    'ordered-list': (_, children) => `<ol>${children}</ol>`,
    'list-item': (_, children) => `<li>${children}</li>`,
};
